import { defineLocale } from "../../registry";

const states = defineLocale({
  ru: {
    "states.empty.catalog": "Каталог пуст",
    "states.empty.filtered": "Нет результатов по фильтрам",
    "states.empty.create": "Создать Pick",
    "states.empty.clearFilters": "Сбросить фильтры",
  },
  en: {
    "states.empty.catalog": "No picks yet",
    "states.empty.filtered": "No picks match these filters",
    "states.empty.create": "Create pick",
    "states.empty.clearFilters": "Clear filters",
  },
});

export default states;
